import { strokePlayNet } from "./strokePlayNet.js";
import { strokePlayGross } from "./strokePlayGross.js";
import { stableford } from "./stableford.js";
import { fourBall } from "./fourBall.js";
import { scramble } from "./scramble.js";
import { shamble } from "./shamble.js";
import { alternateShot } from "./alternateShot.js";
import { matchPlay } from "./matchPlay.js";
import { skins } from "./skins.js";
import { wolf } from "./wolf.js";
import type { Format } from "./types.js";

export const formats: Record<string, Format> = {
  [strokePlayNet.id]: strokePlayNet,
  [strokePlayGross.id]: strokePlayGross,
  [stableford.id]: stableford,
  [fourBall.id]: fourBall,
  [scramble.id]: scramble,
  [shamble.id]: shamble,
  [alternateShot.id]: alternateShot,
  [matchPlay.id]: matchPlay,
  [skins.id]: skins,
  [wolf.id]: wolf,
};

export function getFormat(id: string): Format {
  const format = formats[id];
  if (!format) throw new Error(`Unknown format id: ${id}`);
  return format;
}

export * from "./types.js";
export {
  strokePlayNet,
  strokePlayGross,
  stableford,
  fourBall,
  scramble,
  shamble,
  alternateShot,
  matchPlay,
  skins,
  wolf,
};
export { suggestNextWolf } from "./wolf.js";
